<template>
  <!--专家角色登录后显示的首页，显示专家所在的所有申报评审，在申报列表中以路由push方式进入指定申报评审页面ReviewMark，传入申报ID-->
  <v-card class="main-content-card" flat id="proj-index-review">
    <v-toolbar flat>
      <v-toolbar-title>我的评审</v-toolbar-title>
      <span class="subheading ml-2">|</span>

    </v-toolbar>

    <v-divider/>

    <v-form ref="formRef">
      <v-container grid-list-md class="pt-0">
        <v-layout wrap>
          <v-flex xs3>
            <v-text-field
                label="申报名称"
                :rules="rules.required"
                v-model="form.name"
            />
          </v-flex>

          <v-flex sm3>
            <v-menu
                ref="refReviewStart"
                :close-on-content-click="false"
                v-model="menuReviewStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.reviewStart"
                  label="申报日期(起始)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="reviewStart"
                  locale="zh-cn"
                  @change="nv => form.reviewStart= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm3>
            <v-menu
                ref="refReviewEnd"
                :close-on-content-click="false"
                v-model="menuReviewEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.reviewEnd"
                  label="申报日期(截止)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="reviewEnd"
                  locale="zh-cn"
                  @change="nv => form.reviewEnd= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm2>
            <v-autocomplete
                clearable
                v-model="form.reviewStatusId"
                item-text="name"
                item-value="dbid"
                :items="reviewStatusItems"
                label="状态"
            />
          </v-flex>

          <v-flex sm1 class="text-xs-right">
            <v-btn color="primary" @click.native="onSearch">检索</v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-form>

    <v-divider/>

    <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-0"
        :loading="isLoading"
        :pagination.sync="query"
        :rows-per-page-items="[25, 50, 100]"
        no-data-text="没有数据。">
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.index + 1 }}</td>
        <td class="">{{ props.item.name }}</td>
        <td class="">{{ props.item.startDate }}</td>
        <td class="">{{ props.item.finishDate }}</td>
        <td class="">{{ props.item.pubDate }}</td>
        <td class="">{{ props.item.operator }}</td>

        <td>
          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="() => { history=props.item.history; hist = true; }">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>
        </td>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { viewDbid = props.item.dbid; view = true; }">
            <v-icon color="teal">more_horiz</v-icon>
          </v-btn>
          <span>查看</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click.native ="() => { $router.push(`/proj/review/mark/${props.item.dbid}`) }"
                 >
            <v-icon color="teal" small>fa-edit</v-icon>
          </v-btn>
          <span>评审</span>
        </v-tooltip>

      </template>
    </v-data-table>

    <x-history
        v-model="hist"
        :history="history"
        :status="statusItems"
    />

    <x-view
        v-model="view"
        :dbid="viewDbid"
    />


  </v-card>
</template>

<script>
import XHistory from "@/components/global/History";
import XUploader from '@/components/global/Uploader'
import XView from './ViewReview'
const baseURI = '/api/proj/review/expert';
const reviewStatusUri = '/api/proj/review-status';
const statusUri = '/api/proj/status';
const baseProUri = '/api/proj/project';
const expertURI = '/api/syst/expert/expert';
export default {
  name: "ExpertReview",
  components: {XHistory, XUploader, XView},
  data: () => ({
    form: {
      name: '',
      reviewStart: '',
      reviewEnd: '',
      reviewStatusId: ''
    },

    formDecValid: false,

    query: {
      page: 1,
      rowsPerPage: 25,
      sortBy: 'rkrq',
      descending: true,
      totalItems: null
    },

    curReviewId: '',

    items: [],
    isLoading: false,

    reviewStart: '',
    menuReviewStart: false,

    reviewEnd: '',
    menuReviewEnd: false,

    reviewStatusItems : [],
    statusItems: [],

    proj: {},
    projItems: [],
    declareItems : [],

    expert: {},

    hist: false,
    history: [],

    projDeclare: false,

    view: false,
    viewDbid: null,

    mark: false,

    fileUri: '/api/papr/file',

    headers: [
      {
        text: '#',
        sortable: false,
        value: 'dbid',
        width: '20'
      },
      // {text: '#', sortable: false, value: 'rank', width: 18},
      {text: '申报名称', sortable: false, value: 'name', align: 'left'},
      {text: '开始日期', sortable: false, value: 'startDate', width: 150, align: 'left'},
      {text: '截止日期', sortable: false, value: 'finishDate', width: 150, align: 'left'},
      {text: '发布日期', value: 'pubDate', sortable: false, align: 'left', width: 200},
      {text: '发布人', value: 'operator', sortable: false, align: 'center', width: 120},
      {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "60"}
    ],


    /**
     * 验证规则
     */
    rules: {
      required: [
        v => !!v || '必填项。',
      ],
    }

  }),

  methods: {
    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.isLoading = true;
      this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
          .then(
              rsp => {
                this.isLoading = false;
                this.items = rsp.data.items;
                window.console.log("this.items")
                window.console.log(this.items)
              })
          .finally(() => this.isLoading = false);
    },
  },

  mounted() {window.console.log("exp")
    Object.assign(this.query, this.form);
    this.query.page = 1;
    this.isLoading = true;
    this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
        .then(
            rsp => {
              this.isLoading = false;
              this.items = rsp.data.items;
              this.items = this.items.filter(item => item.statusId == 'review')
              window.console.log("我的评审项目")
              window.console.log(this.items)
            })
        .finally(() => this.isLoading = false);
  },

   async created() {
    window.console.log("创建")
    let t = 'review'

      await this.axios.all([
      this.axios.get(reviewStatusUri, {params: {sort: 'rank.asc'}}),
      this.axios.get(`${statusUri}/${t}`, {params: {sort: 'rank.asc'}}),
      this.axios.get(`${baseProUri}/by/request/user`),
      this.axios.get(expertURI)])
        .then(
            this.axios.spread(
                (rspReviewStatus,rspStatus,rspPro,rspExp) => {
                  this.isLoading = false;
                  this.statusItems = rspStatus.data;
                  this.reviewStatusItems = rspReviewStatus.data.items;
                  this.projItems = rspPro.data.items;
                  this.projItems = this.projItems.filter(item => item.statusId === 'draft')
                  this.expert = rspExp.data
                })
        )
  }
}
</script>

<style scoped>

</style>